// extracted by mini-css-extract-plugin
export default {"carousel":"productsListPage_carousel__Jq-6N","searchFilter":"productsListPage_searchFilter__lzfYV","row":"productsListPage_row__hNhi7"};